import {
  SourceRequest,
  GetAllSourcesResponse,
  RetryProcessingSourceRequest,
} from "interfaces";
import axiosInstance from "utils/AxiosInterceptor";

export const getSources = async (...args: any) => {
  let url = `api/sources/get-sources?`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });

  return axiosInstance.get<GetAllSourcesResponse>(url);
};

export const deleteSource = async (sourceId: string, projectId?: string) => {
  let url = `api/sources/delete?sourceId=${sourceId}`;
  if (projectId) {
    url += `&projectId=${projectId}`;
  }
  return axiosInstance.delete(url);
};

export const addSource = async (payload: SourceRequest) => {
  return axiosInstance.post("api/sources/add", payload);
};
export const editSource = async (payload: SourceRequest) => {
  return axiosInstance.put("api/sources/update", payload);
};
export const checkName = async (name: string) => {
  return axiosInstance.get(`api/sources/check-name?name=${name}`);
};
export const checkIsbn = async (isbn: string) => {
  return axiosInstance.get(`api/sources/check-isbn?isbn=${isbn}`);
};
export const uploadFile = async (
  file: any,
  signal: any,
  onUploadProgress: any
) => {
  return axiosInstance.post(`api/sources/upload`, file, {
    headers: {
      Accept: "application/json",
    },
    signal: signal,
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      let percent = Math.floor((loaded * 100) / total!);
      onUploadProgress(percent);
    },
  });
};

export const getDetailSource = async (sourceId: string, projectId?: string) => {
  let url = `api/sources/detail?sourceId=${sourceId}`;
  if (projectId) {
    url += `&projectId=${projectId}`;
  }
  return axiosInstance.get(url);
};

export const downloadSourceFile = async (sourceId: string) => {
  return axiosInstance.get(`api/sources/download?sourceId=${sourceId}`, {
    responseType: "blob",
  });
};

export const retryProcessingSource = async (
  payload: RetryProcessingSourceRequest
) => {
  return axiosInstance.post(`api/sources/retry`, payload);
};

export const getStateSource = async (sourceId: string) => {
  return axiosInstance.get(
    `api/sources/check-source-status?sourceId=${sourceId}`
  );
};
